import { useAxios } from 'hooks/useAxios';
import { parsePowerProfileCsv } from 'pages/Blueprints/utils/parsePowerProfileCsv';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { BLUEPRINT_POWER_PROFILE_CACHE_KEY } from 'services/queryKeys';

interface UseGetBlueprintPowerProfileParams {
  blueprintId: string;
  enabled?: boolean;
}

export const useGetBlueprintPowerProfile = ({ blueprintId, enabled = true }: UseGetBlueprintPowerProfileParams) => {
  const { axiosRequest } = useAxios();

  const {
    data: csvData,
    isLoading,
    isError,
    error,
  } = useQuery(
    BLUEPRINT_POWER_PROFILE_CACHE_KEY(blueprintId),
    async () => {
      const response = await axiosRequest({
        method: 'GET',
        path: `/blueprints/${blueprintId}/power-profile/?response_format=csv`,
      });
      return response.data as string;
    },
    {
      enabled: enabled && !!blueprintId,
    }
  );

  const powerProfileData = useMemo(() => {
    if (!csvData) {
      return undefined;
    }
    return parsePowerProfileCsv(csvData);
  }, [csvData]);

  return {
    powerProfileData,
    isLoading,
    isError,
    error,
  };
};
